module.exports = __webpack_public_path__ + "static/basics-product-a9bf5619ad141f4e63c3809e54dcf5f1.svg";